module.exports = __webpack_public_path__ + "fonts/iconfont.23f8cf47.ttf";